import React from "react";
import styles from "./emptyMessage.module.scss";
import Button from "../button";
import cx from "classnames";

interface EmptyMessageProps {
  image?: string;
  heading?: string;
  message?: string;
  action?: {
    title: string;
    icon?: string;
    onClick: () => void;
  }
  width?: string | number | undefined;
  className?: string;
}
const EmptyMessage: React.FC<EmptyMessageProps> = ({ image, heading, message, action, width, className }) => {
  return <div className={cx(styles.container, className)} style={{ width: width }}>
    {image && <img className={styles.image} src={image} alt={heading} />}
    {heading && <h2 className={styles.heading}>{heading}</h2>}
    {message && <p className={styles.message}>{message}</p>}

    {action &&
      <Button className={styles.action} onClick={action.onClick} icon={action.icon} variant="primary" text={action.title} />
    }
  </div>;
};

export default EmptyMessage;
